export default "__VITE_ASSET__BrdCVVOS__"